import { render } from "./ProfileEditPage.vue?vue&type=template&id=b5130dd8&scoped=true"
import script from "./ProfileEditPage.vue?vue&type=script&lang=js"
export * from "./ProfileEditPage.vue?vue&type=script&lang=js"

import "./ProfileEditPage.vue?vue&type=style&index=0&id=b5130dd8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5130dd8"]])

export default __exports__